import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { EVENTS } from '../../utilities/CONSTANTS';
import { getDraftUrl } from '../../utilities/urlHelper';

import EditLockModal from './EditLockModal';

class EditLockWrapper extends React.Component {
    state = {
        showModal: true,
    };

    componentDidMount() {
        if (!window._tettraUsers) {
            window.addEventListener(EVENTS.USERS_LOADED, this.forceUpdate);
        }
    }

    componentWillUnmount() {
        window.removeEventListener(EVENTS.USERS_LOADED, this.forceUpdate);
    }

    render() {
        const { showModal } = this.state;
        if (!window._tettraUsers || !showModal) return null;
        const {
            existingDraft: { author_id: authorId, team_slack_id: authorTeamSlackId },
        } = this.props;
        const author = window._tettraUsers.find((u) => u.id == authorId);
        const {
            display_name: authorName,
            slack_id: authorSlackId,
            image_192: authorImage,
            email: authorEmail,
        } = author || {};
        const discardUrl = getDraftUrl(window.draftId);
        return createPortal(
            <EditLockModal
                existingDraft={{
                    authorEmail,
                    authorId,
                    authorImage,
                    authorName,
                    authorSlackId,
                    authorTeamSlackId,
                    discardUrl,
                }}
                closeModal={() => this.setState({ showModal: false })}
            />,
            document.body,
        );
    }
}

export default EditLockWrapper;
